module.exports = __webpack_public_path__ + "img/segura-icon.8a50a4d6.png";